<template>
  <div style="margin-top: 30px">
    <div class="topclass">
      <el-card :body-style="{padding:'0px'}" style="border-radius: 8px 8px 0 0">
        <!-- 课程视频播放区 -->
        <div class="video-left" :data-course_id="course_info.course_id">
          <video id="tc-player" style="width: 100%;height: 100%" :poster="course_info.course_cover"/>
          <div v-if="stopShow" class="vtitle">
            <div class="vtitletop">{{ stopTextTip }}</div>
            <div class="vtitlecentent">{{ stopTextContent }}</div>
          </div>
        </div>
        <!--右侧功能区-->
        <div class="video-right">
          <div class="videother">
            <el-tabs style="height: 516px;overflow: auto;" :stretch=true>
              <!--视频列表-->
              <el-tab-pane label="目录">
                <div id="videoList" style="height: 477px;  overflow: scroll;">
                  <div v-if="video_table.videoList==''" class="fff">
                    暂无视频
                  </div>
                  <video-table v-for="(module,index) in video_table.videoList"
                               :video_table="module"
                               :current_id="video_now.videoId"
                               :key="module.id"
                               :has_buy="has_buy"
                               ref="chapterList"
                               v-on:childmethods="gotoVideoById">
                  </video-table>
                </div>
              </el-tab-pane>
              <!--讨论区-->
              <el-tab-pane label="讨论" @click="getchat">
                <ul class="discuss_list">
                  <interaction-li v-for="(item, index) in chatList" :key="index" :item="item" :index="index">
                  </interaction-li>
                </ul>
                <div style="height: 50px;padding-left: 5px;margin-top:20px">
                  <el-form :inline="true" :model="chatform" ref="chatform" onsubmit="return false;">
                    <el-form-item>
                      <el-input class="inputmsg" v-model="chatform.msg" @keyup.enter.native="postChat"></el-input>
                    </el-form-item>
                    <el-form-item style="margin-bottom: 0">
                      <el-button v-if="has_buy" type="primary" class="hkbtn" @click="postChat">
                        <a>发言</a>
                      </el-button>
                      <el-button v-if="!has_buy" type="primary" class="hkbtn_no">
                        <a>发言</a>
                      </el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-card>
    </div>
    <!--标题-->
    <el-card :body-style="{padding:'0px'}" style="border-radius: 0 0 8px 8px">
      <div
        style="display: flex; flex-direction: row;width: 100%;align-items: center;padding: 15px;border-top: 1px solid #f2f2f2">
        <div>
          <div class="vdtitle">{{ course_info.course_name }}</div>
          <div>
            <a class="vdspanrig">{{ course_info.video_num }}课时</a>
            <a class="vdspanrig">{{ course_info.subscribe_num }}人已听课</a>
          </div>
        </div>
        <button v-if="!has_buy && course_info.course_price > 0" @click.stop.prevent="gotoOrder" class="notbuy">
          {{ "¥" + course_info.course_price + ' 立即购买' }}
        </button>
        <button v-if="!has_buy && course_info.course_price <= 0" @click.stop.prevent="gotoOrder" class="notbuy">
          {{ "免费报名" }}
        </button>
        <button v-if="has_buy" class="hasbuy">
          {{ '已购买' }}
        </button>
      </div>
    </el-card>
    <!--简介-->
    <div style="margin-top: 30px">
      <el-row :gutter="40">
        <el-col :span="16">
          <el-card :body-style="{padding:'0px'}" style="border-radius: 8px">
            <div style="display: flex;flex-direction: column;">
              <div style="margin: 10px;display: flex;flex-direction: row;align-items: center">
                <div style="width: 5px;height: 18px;background-color: #ffbc42;border-radius: 8px"/>
                <a style="font-size: 18px;color: #333333;margin-left: 10px">课程介绍</a>
              </div>
              <img :src="course_info.intro_pic" class="w100">
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card :body-style="{ padding: '0'}" style="border-radius: 8px">
            <div style="display: flex;flex-direction: column;">
              <div style="margin: 10px;display: flex;flex-direction: row;align-items: center">
                <div style="width: 5px;height: 18px;background-color: #ffbc42;border-radius: 8px"/>
                <a style="font-size: 18px;color: #333333;margin-left: 10px">主讲教师</a>
              </div>
              <div style="height: 1px;width: 100%;background-color: #f2f2f2"/>
              <ul class="teachers">
                <li v-for="teacher in course_info.teachers" :data-teacher_id="teacher.teacher_id">
                  <div
                    style="display: flex;flex-direction: column;align-items: center;justify-content: center;margin-top: 25px">
                    <img style="width: 100px;height: 90px;border-radius: 8px;" :src="teacher.teacher_head">
                    <a style="margin-top: 10px;text-align: center;font-size: 14px">{{ teacher.teacher_name }}</a>
                  </div>
                </li>
              </ul>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>{{ '您上次观看到了 ' + dialogTitle + ' 是否继续播放?' }}</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose(false)">取 消</el-button>
    <el-button type="primary" @click="handleClose(true)">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import urls from '../../common/js/urls.js'
// 组件
import InteractionLi from './InteractionLi'
import VideoTable from './VideoTable'
import {api_course_detail} from "../../networks/CourseHandler"
import {api_course_videos} from "../../networks/CourseHandler"
import {api_video_live_status} from "../../networks/CourseHandler"
import {api_video_live_chat_list} from "../../networks/CourseHandler"
import {api_video_report_record} from "../../networks/CourseHandler"
import {api_video_send_chat} from "../../networks/CourseHandler"

export default {
  name: "video-page",
  components: {
    InteractionLi,
    VideoTable,
  },
  data() {
    return {
      course_info: {
        saleStopTime: '',
        average_score: 10, //分数
        video_num: 0, //课时数
        course_desc: '', //课程描述
        tag: {}, //#tag 非必选项，有可能没有，如果没有，tag整个标签不会返回
        handouts_name: "", //讲义名称
        handouts_url: '', //讲义地址
        course_id: '', //课程id
        need_address: 1, //是否需要地址
        course_name: '', //课程名称
        subscribe_num: 0, //听课人数
        evaluate_num: 0, //评价人数
        is_live: 0,
        is_vip_free: 0,
        course_cover: '', //课程封面
        teachers: [],
        course_price: 0, //课程价格
        intro_pic_crops: [], //课程详情图片
        teacher_super_cover: '',
        intro_pic: '', //课程介绍图片
        apple_id: '',
        apple_price: '',
        course_protocal: '',
      },
      first_create_player: true,
      has_buy: false,
      course_list_name: '课程表',
      latest_video_record: {},
      video_table: {
        timestamp: '0000000000',
        title: '',
        videoList: []
      },
      video_now: {
        beyondTime: 0,
        canPlayNum: 999999,
        channelId: '',
        chapterId: '',
        courseId: '',
        createTime: '',
        duration: 0,
        endTime: '',
        glFileId: '', //
        handoutsUrl: '', //
        hls_url: '', //
        isLive: 0,
        is_vip: 0,
        liveUrl: '',
        startTime: '',
        videoAdressMp4Bq: '', //视频地址
        videoId: '',
        h5_url:'',
        videoIndex: '1',
        videoName: "",
        videoSize: 0,
        videoTypeId: '',
        live_status: -1, //直播状态
        module_type: 1,
        play_info: {
          sdPlayurl: '',
          hdPlayurl: '',
          hdVideoSize: 0,
        }
      },
      chatList: [],
      chatform: {
        msg: '',
      },
      chattime: 0,
      video_player: {},
      showcourselist: false,
      is_create_chat_room: 0,//是否创建聊天室
      user_id: '',
      isShowIM: false,
      stopTextTip: '',
      stopTextContent: '',
      stopShow: false,
      dialogVisible: false,
      dialogTitle: '',
      video_now_index: 0,
      video_now_childIndex: 0,
      try_count:0,
    }
  },
  computed: {
    router_course_id() {
      return this.$route.params.course_id
    },
    router_video_id() {
      return this.$route.params.video_id
    },
    current_user() {
      return this.$store.state.user
    }
  },
  watch: {
    video_now(val) {
      if (!$.isEmptyObject(val)) {
        if (val.isLive === 1) {
          this.checkVideoLive(val);
        } else {
          this.createVideoPlayer();
        }
      }
    },
    'current_user.user_id': {
      handler: function (val, oldVal) {
        if (val !== "" && val != null) {
        }
      },
      deep: true
    },
    has_buy(val, oldVal) {
      // if (val && !oldVal) this.createVideoPlayer()
    },
  },
  created: function () {
    this.getCourseDetail(this.router_course_id) // 获取课程信息
    var application_id = 1;
    this.$store.dispatch('update_application', application_id);
  },
  destroyed: function () {
    clearInterval(this.chat_timer);
    if (!$.isEmptyObject(this.video_player)) {
      this.video_player.dispose();
      this.video_player = {};
    }
  },
  methods: {
    // 获取课程信息
    getCourseDetail: function (course_id) {
      var context = this;
      var promise = api_course_detail(context, course_id);
      promise.then(function (data) {
        context.drawCourseDetail(data);
      }).catch(function (error) {
      });
    },
    drawCourseDetail: function (data) {
      this.course_info = data.course_info;
      this.course_list_name = data.course_list_name;
      this.latest_video_record = data.latest_video_record;
      this.has_buy = data.has_buy;
      this.is_create_chat_room = data.course_info.is_create_chat_room;
      if (!this.has_buy) { //如果未购买
        if (this.course_info.course_stage !== 2 && this.course_info.course_status !== 1) {
          $(".notbuy").html("已下架");
          $(".notbuy").addClass('unabled');
        }
      }
      this.getCourseVideos(this.router_course_id);
    },
    getCourseVideos: function (course_id) {
      var context = this;
      var user_id = context.current_user.user_id;
      var promise = api_course_videos(context, course_id, user_id);
      promise.then(function (data) {
        context.drawCourseVideos(data);
      }).catch(function (error) {
      });
    },
    // 获取视频列表
    drawCourseVideos: function (data) {
      this.video_table = {};
      this.video_table = data.result;
      if ($.isEmptyObject(data.result.videoList)) {
        $("#chatcard").addClass('hide');
        $("#kcbcard").addClass('hide');
      }
      this.video_now = {};
      if (!this.has_buy) {
        // alert("您未购买该课程！")
        return
      }
      if (!$.isEmptyObject(this.latest_video_record)) {
        this.dialogTitle = this.latest_video_record.video_name;
        this.dialogVisible = true;
      } else {
        if (this.video_table.videoList[0] && this.video_table.videoList[0].videos[0] &&
          this.video_table.videoList[0].videos[0].module_type === 1) {
          this.video_now = this.video_table.videoList[0].videos[0];
        }
      }
    },
    // 根据视频列表播放视频  video_id更改video_now
    gotoVideoById: function (video_id, videoTypeId) {
      if (videoTypeId === '201703131201518576196927') {
        this.freeLook(video_id);
        return true
      }
      if (!this.has_buy) {
        this.$message.error("您未购买该课程");
        return false
      }
      if (this.video_now.videoId === video_id) {
        return false
      }
      if (!$.isEmptyObject(this.video_now)) {
        this.addVideoRecord()
      }
      for (var i = 0; i < this.video_table.videoList.length; i++) {
        for (var j = 0; j < this.video_table.videoList[i].videos.length; j++) {
          // 遍历videoList，查找指定的video==item
          var item = this.video_table.videoList[i].videos[j];
          if (item.videoId === video_id) {
            this.video_now_index = i;
            this.video_now_childIndex = j;
            this.video_now = {};
            this.video_now = item;
            return true;
          }
        }
      }
    },
    // 创建视频播放窗口
    createVideoPlayer: function (opt) {
      let context = this;
      if (!this.has_buy && this.video_now.videoTypeId !== '201703131201518576196927') {
        return
      }
      if (!this.current_user.user_id || this.current_user.user_id === '') {
        this.$message({
          message: '请登录后观看直播',
          type: 'warning'
        });
        this.$router.push({
          path: '/login'
        })
        return false;
      }
      if ($.isEmptyObject(this.video_player)) {
        this.video_player = TCPlayer('tc-player', this.initPlayerParams(true));
        this.video_player.on('error', function (error) {
          if (context.video_now.isLive === 0 && (context.course_info.course_name.match(/四阶段/))) {
            context.video_player.src('https://1251323988.vod2.myqcloud.com/' + context.video_now.play_info.sdPlayurl + '/v.f20.mp4');
          }
        });
        this.video_player.on('ended', function (ended) {
          context.loadNext();
        });
      }
      if (this.video_now.isLive === 0) { //点播
        this.stopShow = false;
        if (!this.router_course_id || this.router_course_id === '' || !this.video_now.glFileId || this.video_now.glFileId === '') {
          alert("播放文件错误！请刷新重试")
          return false;
        }
        this.video_player.pause();
        // this.video_player.loadVideoByID(this.initPlayerParams(false));
        var playUrl = ''
        if (context.course_info.course_name.match(/四阶段/) || context.course_info.course_name.match(/全科/)
          || context.course_info.course_name.match(/系统提升班/) || context.course_info.course_name.match(/笔试/)) {
          console.log("四阶段")
          if (context.video_now.play_info.hdPlayurl !== '') {
            playUrl = 'https://1251323988.vod2.myqcloud.com/' + context.video_now.play_info.hdPlayurl + '/v.f30.mp4'
          } else if (context.video_now.play_info.hdPlayurl === '') {
            playUrl = 'https://1251323988.vod2.myqcloud.com/' + context.video_now.play_info.sdPlayurl + '/v.f100030.mp4'
          } else {
            playUrl = 'https://1251323988.vod2.myqcloud.com/' + context.video_now.play_info.sdPlayurl + '/v.f20.mp4'
          }
          this.video_player.on('error', function (ended) {
              playUrl = 'https://1251323988.vod2.myqcloud.com/' + context.video_now.play_info.sdPlayurl + '/v.f20.mp4'
              context.video_player.src(playUrl);
          });
        } else {
          console.log("非四阶段")
          if(context.video_now.play_info.hdVideoSize > 0){
            playUrl = 'https://1251323988.vod2.myqcloud.com/' + context.video_now.play_info.sdPlayurl + '/v.f100030.mp4'
          } else {
            playUrl = 'https://1251323988.vod2.myqcloud.com/' + context.video_now.play_info.sdPlayurl + '/v.f20.mp4'
          }
          this.video_player.on('error', function (ended) {
            playUrl = 'https://1251323988.vod2.myqcloud.com/' + context.video_now.play_info.sdPlayurl + '/v.f20.mp4'
            context.video_player.src(playUrl);
          });
        }
        this.video_player.src(playUrl);
        setTimeout(function () {
          if (context.video_now.beyondTime < context.video_now.duration) {
            context.video_player.currentTime(context.video_now.beyondTime);
          }
        }, 500);
      } else { //直播
        if (this.video_now.live_status === '1') {
          if (context.video_now.liveUrl.startsWith("http://")) {
            context.video_now.liveUrl = context.video_now.liveUrl.replace("http://", "https://")
          }
          console.log("当前直播状态4", context.video_now.live_status)
          this.video_player.src(context.video_now.liveUrl);
        }
      }
    },
    // 上传视频观看记录
    addVideoRecord: function () {
      var context = this;
      if (!this.has_buy) return false
      if (!this.current_user.user_id || this.current_user.user_id === '') return false
      if ($.isEmptyObject(this.video_player)) return false
      if (!this.video_now.isLive === 1) return false
      var recordTime = context.video_player.currentTime().toFixed(0);
      var beyondTime = context.video_now.beyondTime;
      this.video_table.videoList[this.video_now_index].videos[this.video_now_childIndex].beyondTime = recordTime;
      if (recordTime <= 10 || recordTime - beyondTime < 60) {
      } else {
        var promise = api_video_report_record(context, recordTime);
        promise.then(function (data) {
        }).catch(function (error) {
        });
      }
    },
    // 互动：
    getChatList: function (course_id) {
      if (!this.has_buy) { //如果未购买
        return
      }
      var context = this;
      var promise = api_video_live_chat_list(context, course_id);
      promise.then(function (data) {
        context.chatList = data.result.chatList.reverse();
        if (context.chatList) {
          if (context.chatList.length > 0) {
            var last = context.chatList[context.chatList.length - 1];
            $(".discuss_list").scrollTop($(".discuss_list").prop('scrollHeight'));
            $("#kcbcard").addClass('hide');
          } else {
            $("#chatcard").addClass('hide');
          }
        }
      }).catch(function (error) {
      });
    },
    //互动发言
    postChat: function () {
      if (this.isShowIM) {
        //聊天室
      } else {
        //互动
        if (!this.current_user.user_id || this.current_user.user_id == '') {
          this.$message({
            message: '请先登录',
            type: 'warning'
          });
          this.$router.push({
            path: '/login'
          })
          return;
        }
        $(".inputmsg input").val('');
        var context = this;
        var promise = api_video_send_chat(context);
        promise.then(function (data) {
          context.getChatList(context.router_course_id);
        }).catch(function (error) {
          context.$message.error('抱歉没有发送成功，请稍后再试');
        });
      }
    },
    // 前往订单
    gotoOrder: function () {
      if (!this.current_user.user_id || this.current_user.user_id === '') {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push({
          path: '/login'
        })
      } else {
        if (this.course_info.course_price > 0) {
          //判断是否已下架
          if (this.course_info.course_stage !== 2 && this.course_info.course_status !== 1) {
            this.$message.error('该课程已下架，请看其他课程');
          } else {
            if (this.course_info.course_protocal) {
              this.$router.push({
                name: 'Order',
                query: {
                  pId: this.course_info.course_id,
                  course_protocal: this.course_info.course_protocal
                }
              })
            } else {
              this.$router.push({
                name: 'Order',
                query: {
                  pId: this.course_info.course_id
                }
              })
            }
            return false
          }
        }
        // 处理免费课程：
        else {
          var _this = this
          //-------------添加到我的课程---------------
          this.axios.post(urls.add_to_mycourse + '?userid=' + this.current_user.user_id + '&courseId=' + this.course_info.course_id).then(function (response) {
            console.log(response.data)
            if (response.data && response.data.code === "200") {
              _this.has_buy = true
              _this.getCourseDetail(_this.router_course_id)
            } else {
              _this.$message.error('请刷新页面');
            }
          }).catch(function () {
            _this.$message.error('因为网络问题，请求没有成功，请稍后再试');
          })
        }
      }
    },
    // 判断直播状态：
    checkVideoLive: function (current_video) {
      if (current_video.isLive === 0) {
        this.createVideoPlayer();
        return false;
      }
      if (!$.isEmptyObject(this.video_player)) {
        this.video_player.pause();
      }
      var context = this;
      var promise = api_video_live_status(context, current_video);
      promise.then(function (data) {
        var res = data.result;
        context.video_now.live_status = res.liveStatus.toString();
        console.log("当前直播状态1", context.video_now.live_status)
        if (context.video_now.live_status === "1") { //正在直播
          context.stopShow = false;
          if (!context.isShowIM && context.has_buy) {
            console.log("当前直播状态2", context.video_now.live_status)
            context.chat_timer = setInterval(function () {
              if (!context.router_course_id || context.router_course_id === '')
                return false;
              context.getChatList(context.router_course_id);
            }, 3000);
          }
          console.log("当前直播状态3", context.video_now.live_status)
          context.createVideoPlayer();
        } else if (context.video_now.live_status === '0') { //直播未开始
          //互动
          if (!context.router_course_id || context.router_course_id === '') return false
          var str = context.video_now.startTime;
          var s1 = str.substring(0, str.length - 3);
          var n = s1.replace("T", " ");
          context.stopTextTip = '直播未开始';
          context.stopTextContent = "开始时间 " + n;
          context.stopShow = true;
          if (!context.isShowIM) {
            context.getChatList(context.router_course_id);
          }
        } else if (context.video_now.live_status === '3') { //直播已结束
          if (!context.router_course_id || context.router_course_id === '') return false
          var atr = context.video_now.endTime;
          var a1 = atr.substring(0, atr.length - 3);
          var m = a1.replace("T", " ");
          context.stopTextTip = '直播已结束';
          context.stopTextContent = "结束时间 " + m;
          context.stopShow = true;
          if (!context.isShowIM) {
            context.getChatList(context.router_course_id);
          }
        }
      }).catch(function (error) {
      });
    },
    showCourse: function () {
      this.showcourselist = true;
      $('.videother').animate({
        scrollTop: 230
      }, 10);
    },
    getchat: function () {
      this.getChatList(this.router_course_id);
    },
    initPlayerParams(init) {
      if (init) {
        const controlBar = {}
        // if (this.course_info.course_name.match(/四阶段/)) {
        //   controlBar.QualitySwitcherMenuButton = true
        // } else {
        //   controlBar.QualitySwitcherMenuButton = false
        // }
        // const controlBar = {
        //   QualitySwitcherMenuButton: false,
        // };
        const playerConfig = {
          //  fileID: this.video_now.glFileId,
          appID: '1251323988',
          poster: this.course_info.course_cover,
          autoplay: true,
          posterImage: true,
          bigPlayButton: true,
          // controlBar: controlBar,
        };
        return playerConfig;
      } else {
        const playerConfig = {
          //  fileID: this.video_now.glFileId,
          appID: '1251323988',
        };
        return playerConfig;
      }
    },
    handleClose(done) {
      let context = this;
      if (done) {
        context.$refs.chapterList[0].scrollToChild(context.latest_video_record.video_id);
        context.gotoVideoById(context.latest_video_record.video_id);
      } else {
        if (context.video_table.videoList[0]) {
          context.video_now = context.video_table.videoList[0].videos[0];
        }
      }
      context.dialogVisible = false;
    },
    loadNext: function () {
      if (this.video_now.videoTypeId === '201703131201518576196927') {
        return;
      }
      let a = this.video_now_index;
      let b = this.video_now_childIndex;
      if (b < this.video_table.videoList[a].videos.length - 1) {
        for (var j = b + 1; j < this.video_table.videoList[a].videos.length; j++) {
          let video = this.video_table.videoList[a].videos[j];
          if (!$.isEmptyObject(video) && video.module_type === 1 && video.isLive === 0) {
            this.gotoVideoById(video.videoId);
            return
          }
        }
      } else {
        if (a < this.video_table.videoList.length) {
          for (var i = a + 1; i < this.video_table.videoList.length; i++) {
            for (var j = 0; j < this.video_table.videoList[i].videos.length; j++) {
              var video = this.video_table.videoList[i].videos[j];
              if (!$.isEmptyObject(video) && video.module_type === 1 && video.isLive === 0) {
                this.gotoVideoById(video.videoId);
                return
              }
            }
          }
        }
      }
    },
    freeLook: function (video_id) {
      for (var i = 0; i < this.video_table.videoList.length; i++) {
        for (var j = 0; j < this.video_table.videoList[i].videos.length; j++) {
          var item = this.video_table.videoList[i].videos[j];
          if (item.videoId === video_id) {
            this.video_now = {};
            this.video_now = item;
            return;
          }
        }
      }
    }
  }
}
</script>
<style>

.el-tabs__header {
  margin-bottom: 0;
  box-shadow: 0 2px 8px #e2e2e2;
  z-index: 1;
}

.el-tabs__nav-wrap::after {
  height: 0px;
  background-color: #cccccc;
}

.el-tabs__item {
  padding-left: 10px;
  padding-right: 10px;
  width: 160px;
  align-items: center;
  text-align: center;
  font-size: 14px !important;
  font-weight: normal;
  color: #BDBDBD;
  background-color: #f9f9f9;
}

.el-tabs__item.is-active {
  padding-left: 10px;
  padding-right: 10px;
  width: 160px;
  color: #ffffff;
  align-items: center;
  text-align: center;
  font-size: 14px !important;
  font-weight: normal;
  background-color: #ffbc42;
}

.el-tabs__active-bar {
  height: 0;
}

.vcp-poster-pic {
  width: 100%;
}

.onemsg {
  position: relative;
  padding: 2px 14px;
}

.onemsg .msghead {
  color: #eee;
  line-height: 12px;
  font-size: 12px;
  height: 40px;
  margin: 0;

}

.onemsg .msgbody {
  text-align: left;
  margin: -25px 40px 0 49px;
  line-height: 13px;
  font-size: 14px;
}

.onemsg .msgbody pre {
  border: 0px solid #cccccc !important;
  display: inline-block;
  padding: 7px;
  margin: 0 0 10px -11px;
  font-size: 13px;
  line-height: 1.428571429;
  color: #000;
  background-color: #f5f5f5;
  border-radius: 4px;

  max-width: 150px;
  word-break: break-all;
  word-wrap: break-word;

}


.onemsg .msgbody pre code {
  padding: 0;
  font-size: inherit;
  color: inherit;
  white-space: pre-wrap;
  background-color: transparent;
  border-radius: 0;
  max-width: 150px;
  padding: 0;
  font-size: inherit;
  color: inherit;
  white-space: pre-wrap;
  background-color: transparent;
  border-radius: 0;
}

.el-form--inline {
  height: 35px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.el-form-item__content {
  height: 35px !important;
}

.el-input__inner {
  margin-left: 10px;
  margin-top: 5px;
  height: 35px;
}
</style>


<style scoped>
.topclass .video-left {
  width: 916px !important;
  height: 516px;
  float: left;
  position: relative;
}

.topclass .video-right {
  width: 320px !important;
  float: right;
  height: 516px;
}

.hide {
  display: none;
}

.w73 {
  width: 126px;
  padding-top: 10px;
  float: left;
  box-sizing: border-box;
}

.w100 {
  width: 100%;
}

/*.el-card {*/
/*  border: 1px solid #ebeef5;*/
/*  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, .1);*/
/*  box-shadow: 0 0 0 0 rgba(0, 0, 0, .1);*/
/*  cursor: default;*/
/*}*/

.main {
  position: relative;
}

.container-fluid {
  width: 1237px;
  margin: auto;
  text-align: center;
}

.eltab {
  background-color: #fff;
  padding: 23px;
  border: 1px solid #eee;
}

.mt70 {
  margin-top: 35px;
  font-size: 20px;
  color: #303133;
  font-weight: normal;
}

.eltab .el-tabs__nav {
  background-color: #000;
}

#tc-player {
  width: 100%;
  height: 100%;
  margin-bottom: 30px;
  position: relative;
}

#tc-player img {
  width: 100%;
  opacity: 0.5;
  height: 516px;
}

.vtitle {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 2;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.vtitletop {
  font-size: 32px;
  color: #fff;
}

.vtitlecentent {
  font-size: 25px;
  color: #fff;
  margin-top: 30px;
  /*font-weight:bold;*/
}

/*右边卡片*/

.vrimg {
  height: 216px;
}

.rank-box {
  margin-top: -5px;
  height: 80px;
}

.rank-box .fl {
  font-family: PingFangSC-Semibold, Microsoft YaHei, Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 36px;
  margin-right: 20px;
  line-height: 50px;
  float: left;
  margin-top: 17px;
  margin-left: 17px;
}

.fl-p {
  /*评价*/
  margin-top: 17px;
  font-size: 14px;
  margin-right: 68px;
  float: right;
}

.lineinfo {
  font-size: 12px;
  text-align: center;
  height: 35px;
}

.lineinfo .el-col {
  padding-top: 10px;
}

.downline {
  width: 100%;
  border-bottom: 1px solid #ebeef5;
}

.leftline {
  height: 100%;
  border-left: 1px solid #ebeef5;
}

.rightline {
  height: 100%;
  border-right: 1px solid #ebeef5;
}

.topbtn {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.topbtnlab {
  font-size: 18px;
  color: #FAB200;
  margin-right: 20px;
  line-height: 41px;
}

.topbtn button {
  border-radius: 0;
  background-color: #e37d28;
  width: 120px;
  height: 43px;
  padding: 14px;
  line-height: 14px;
  font-family: PingFangSC-Semibold, Microsoft YaHei, Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 16px;
  color: #fff;
  border: 0px solid #ebeef5;
  cursor: pointer;
}

#chatcard {
  border-radius: 0 !important;
}

/*老师列表*/

.teachers {
  list-style: none;
  margin-left: -15px;
  margin-top: -5px;
}

.teachers li {
  width: 90px;
  margin-right: 30px;
  float: left;
  min-height: 165px;
}

.teachers li .frame {
  width: 100px;
  height: 100px;
}

.frame {
  background: #efefef;
  overflow: hidden;
  position: relative;
}

.frame img:not(.icon) {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.teachers li h5 {
  margin: 3px;
  font-size: 16px;
}

.teachers li p {
  margin: 3px;
  font-size: 12px;
  color: #999;
}

.teachers li:nth-of-type(3n) {
  margin-right: 0;
}

.teachers li:nth-of-type(n+4) {
  margin-top: 20px;
}

/*下载讲义*/

.unabled {
  background-color: #e5e5e5 !important;
}

.download {
  margin-top: 20px;
}

.download button {
  border: 1px solid #e5e5e5;
  background: #FFFFFF;
  border-radius: 4px;
  width: 100%;
  height: 50px;
  padding: 14px;
  line-height: 22px;
  font-family: PingFangSC-Semibold, Microsoft YaHei, Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 16px;
}

.labcolor a,
.download button i,
.download button b {
  color: #e37d28;
}

#tc-player {
  width: 100% !important;
  height: 516px !important;
  margin: 0px auto;
  background-color: #000;
}

/*互动*/

.discuss_list {
  padding: 0 0 0 0;
  overflow: scroll;
  margin-top: 0;
  height: 406px;
  text-align: left;
}

.tlqtitle {
  background-color: #f5f7fa;
  margin-top: -19px;
  padding: 19px 0 1px 16px;
  border-left: 2px solid #ffc809;
}

.tlqtitle h3 {
  line-height: 2px;
}

.el-card {
  margin-bottom: 43px;
}

.el-form {
  text-align: center;
}

.el-form-item {
  margin-bottom: 10px;
}

.trump-in-bg-color {
  /*播放器进度条*/
  background: #1275cf !important;
}

.clright {
  height: 338px;
  overflow: auto;
  margin-bottom: 85px;
}

.kctitle {
  background-color: #f5f7fa;
  padding: 10px 10px 10px 23px;
  border-left: 2px solid #ffc809;
  color: #5c5c5c;
}

.elicon {
  float: right;
  margin-top: -7px;
  margin-right: 10px;
  cursor: pointer;
}

.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
}

.DownApp .form {
  width: 200px;
  padding: 22px 20px 10px;
  margin: auto;
  top: 25%;
  left: 0;
  right: 0;
  background: #fff;
  position: absolute;
  font-size: 12px;
  text-align: center;
  border-radius: 5px;
}

.DownApp .form img {
  width: 200px;
}

.videother {
  background: #ffffff;
  height: 516px;
}

.vdtitle {
  color: #333333;
  font-weight: normal;
  font-size: 22px;
  margin-bottom: 10px;
}

.vdcenter {
  background: #3F3F3F;
  padding-top: 15px;
  padding-bottom: 15px;
  text-align: left;
}

.vdspanlef {
  font-size: 14px;
  color: #fff;
  padding-left: 20px;
}

.vdspancenter {
  font-size: 26px;
  color: #FFBC40;
}

.vdspanrig {
  margin-left: 10px;
  font-size: 14px;
  color: #999999;
}

.vdbottom {
  font-size: 14px;
  color: #BBBBBB;
  padding-left: 20px;
  margin-top: 22px;
  text-align: left;
}

.notbuy {
  width: 200px;
  height: 50px;
  background: #ffbc42;
  color: #ffffff;
  border-radius: 25px;
  border: 1px solid #ffbc42;
  font-size: 18px;
  outline: none;
  cursor: pointer;
  margin-left: auto;
  margin-right: 65px;
}

.hasbuy {
  width: 200px;
  height: 50px;
  background: #cccccc;
  color: #ffffff;
  border-radius: 25px;
  border: 1px solid #cccccc;
  font-size: 18px;
  outline: none;
  cursor: pointer;
  margin-left: auto;
  margin-right: 65px;
}

.notbuyst {
  border: 1px solid #FFBC40;
  width: 108px;
  height: 38px;
  border-radius: 3px;
  margin-top: 32px;
  background: #3C3C3C;
  color: #fff;
  outline: none;
  cursor: pointer;

}

.yjbuy {
  border: 1px solid #e4e7ed;
  width: 108px;
  height: 38px;
  border-radius: 3px;
  margin-top: 32px;
  background: #e4e7ed;
  color: #303133;
  outline: none;
  cursor: pointer;
  margin-right: 30px;
}

.topclass {
  height: 516px;
}

.hkbtn {
  margin-left: 20px;
  margin-right: 5px;
  height: 35px;
  width: 50px;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #ffbc42;
}

.hkbtn_no {
  margin-left: 20px;
  margin-right: 5px;
  height: 35px;
  width: 50px;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #cccccc;
}

.mb80 {
  margin-bottom: 80px;
}

.text-left {
  text-align: left;
}

.fff {
  color: #fff !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Video/Video.vue